import { memo } from "react";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";

interface HashKeysActionButtonsProps {
  selectedCount: number;
  onAddNew: () => void;
  onDelete: () => void;
  isDeleting?: boolean;
}

/**
 * Action buttons component for hash keys management
 */
const HashKeysActionButtons = memo<HashKeysActionButtonsProps>(
  ({ selectedCount, onAddNew, onDelete, isDeleting = false }) => (
    <div className="flex w-auto flex-row gap-2">
      <Button
        icon
        variant="default"
        className="h-[52px] w-auto p-3 text-white"
        onClick={onAddNew}
        disabled={isDeleting}
      >
        <i className="ri-add-line text-md font-light"></i>
        Add
      </Button>
      <Button
        icon
        variant="outline"
        className="text-muted flex h-[52px] w-auto flex-row gap-2 p-3"
        onClick={onDelete}
        disabled={selectedCount === 0 || isDeleting}
      >
        {isDeleting ? (
          <Spinner size="sm" className="stroke-primary!" />
        ) : (
          <i className="ri-delete-bin-line text-md font-light"></i>
        )}
        {isDeleting ? "Deactivating..." : "Deactivate"}
      </Button>
    </div>
  ),
);

HashKeysActionButtons.displayName = "HashKeysActionButtons";

export default HashKeysActionButtons;
